
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from '@shared/services/loader/loader.service';

@Component({
    selector: 'avenir-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit {
  @Input() showText = true;
  @Input() testIdPrefix?: string;
  isLoading = false;
  constructor(
    protected loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.loaderService.isLoading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      this.cdr.detectChanges();
    })
  }
}
